
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.047 6.227A7.347 7.347 0 012.507 8H1.282l-.453-.875c.089-.161.224-.367.406-.617.188-.25.563-.688 1.125-1.313.016-.312.024-.633.024-.96 0-.386-.003-.673-.008-.86a8.782 8.782 0 00-.047-.664 3.114 3.114 0 00-.133-.664A1.334 1.334 0 002 1.625a.619.619 0 00-.523-.258 1 1 0 00-.485.133 2.805 2.805 0 00-.531.375L.1 1.43c.36-.35.69-.607.993-.774.302-.166.607-.25.914-.25.4 0 .7.185.898.555.198.37.297.924.297 1.664 0 .813-.01 1.471-.031 1.977L6.07 2.273c.172-.77.352-1.351.54-1.742h1.226l.508.82c-.406.59-.938 1.23-1.594 1.922-.016.23-.023.706-.023 1.43 0 .64.039 1.143.117 1.508.078.365.182.615.312.75a.68.68 0 00.5.203.957.957 0 00.485-.14c.166-.094.338-.217.515-.368l.36.446a4.457 4.457 0 01-.977.765c-.312.172-.62.258-.922.258-.411 0-.716-.185-.914-.555-.198-.37-.297-.945-.297-1.726 0-.719.021-1.386.063-2L3.047 6.227z","fill":"currentColor"}})])
          )
        }
      }
    